<template>
    <div class="bg-gray w-full">
        <div class="flex flex-wrap w-full">
            <!-- Header -->
            <div class="flex flex-wrap relative py-12 md:py-24 w-full overflow-hidden">
                <strong class="mx-auto text-white text-2xl md:text-4xl relative z-10">{{ title }}</strong>
                <div class="absolute inset-0">
                    <vue-picture v-if="image" :image="image" :style="'w-full h-full object-cover'" :name="title" :notlazy="true" :fph="true" />
                    <div class="absolute inset-0 bg-dgreen mix-blend-multiply opacity-80" aria-hidden="true" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    image: Object,
    title: String,
});
</script>
